import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTransaction({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M15.25 11.8a.75.75 0 010 1.5h-5l.7.93a.75.75 0 01-1.2.9L8.14 13a.75.75 0 01.6-1.2zM11.55.65c.64 0 .98.74.58 1.23l-2.4 2.89c.52.38.97.72 1.35 1.03l.42.33a.75.75 0 01-.97 1.15c-.22-.18-.47-.39-.76-.6l-.46-.36-.51-.37H5.49C2.79 7.68 1.5 9.47 1.5 11.32c0 1.47 1.96 2.55 5.65 2.55a.75.75 0 010 1.5c-4.4 0-7.15-1.51-7.15-4.05 0-2.38 1.51-4.54 4.44-6.48L1.97 1.88A.75.75 0 012.55.65zm1.66 5.95a.75.75 0 011.05.15l1.6 2.13c.36.5 0 1.2-.61 1.2h-6.5a.75.75 0 110-1.5h5l-.7-.93a.75.75 0 01.16-1.05zM9.95 2.15h-5.8l1.48 1.77c.12.15.18.34.17.53h2.5a.75.75 0 01.17-.53l1.48-1.77z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicTransaction.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTransaction.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicTransaction svgRef={ref} {...props} />
));
export default ForwardRef;
